import { DeviceConfigurationValues } from '@/types/deviceConfiguration';
import apiClient from '@/api/client';

export const PartnerConfigurationService = {
    async getAll(): Promise<PartnerConfigurationResponse> {
        const response = await apiClient.get<PartnerConfigurationResponse>('/partner/configurations');
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to retrieve configurations.');
        }

        return result;
      },

    async create(name: string, settings: string, description?: string): Promise<CreatePartnerConfigurationResponse> {
        const response = await apiClient.post<CreatePartnerConfigurationResponse>('/partner/configurations', { 
            name: name,
            description: description, 
            settingsJson: settings
        });

        const result = response.data

        if (response.status != 201) {
            throw new Error('Failed to create configuration.');
        }

        return result;
    },

    async update(id: string, name: string, settings: string, description?: string) {
        const response = await apiClient.put(`/partner/configurations/${id}`, {
            name: name,
            description: description, 
            settingsJson: settings
        });
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to update configuration.');
        }

        return result;
    },

    async delete(id: string) {
        const response = await apiClient.delete(`/partner/configurations/${id}`);
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to delete configuration.');
        }

        return result;
    },

    jsonToConfigValues(json: string): DeviceConfigurationValues {
        try {
          return JSON.parse(json) as DeviceConfigurationValues
        } catch {
          return {}
        }
     }
}

export interface CreatePartnerConfigurationResponse {
    configurationId: string
}


export interface PartnerConfigurationResponse {
    configurations: Configuration[]
}

export interface Configuration {
    id: string
    name: string
    description: string | null
    firmwareVersion: string
    settingsJson: string
    createdAtUtc: string
    updatedAtUtc: string | null
    deviceCount: number
  }